const initialState = {
  listMarketing: [],
  closeTabTargetMarketing: false,
  statusInputTargetMarketing: true,
  statusInputTargetMarketingProduktif: true,
  listTargetMarketing: [],
  listTargetMarketingProduktif: [],
};

const marketingReducer = (state = initialState, action) => {
  let { type, data } = action;
  switch (type) {
    case "SET_CLOSE_TAB_TARGET_MARKETING":
      return {
        ...state,
        closeTabTargetMarketing: data,
      };
    case "SET_ALLMARKETING":
      return {
        ...state,
        listMarketing: data,
      };
    case "SET_STATUS_INPUT_TARGET_MARKETING":
      return {
        ...state,
        statusInputTargetMarketing: data,
      };
    case "SET_ALL_TARGET_MARKETING":
      return {
        ...state,
        listTargetMarketing: data,
      };
    case "SET_STATUS_INPUT_TARGET_MARKETING_PRODUKTIF":
      return {
        ...state,
        statusInputTargetMarketingProduktif: data,
      };
    case "SET_ALL_TARGET_MARKETING_PRODUKTIF":
      return {
        ...state,
        listTargetMarketingProduktif: data,
      };
    default:
      return state;
  }
};
export default marketingReducer;
